/**
 * A finished turn's diff away from the desktop (D414): each changed file of a turn whose `changes` event names its
 * ending checkpoint and repository opens `git.diff { rootId, checkpoint, path }` (the companion contract's
 * `gitDiffRequestSchema`, schemas/companion.ts), DOM-free for the console and the phone.
 *
 *  - {@link turnDiffParams}: the call's params, with the session's own ids so the platform can tell, on a node, that
 *    the person the session runs for is reading their own session's turn (the workbench ignores them).
 *  - {@link unifiedPatchOf}: the answer's files as a unified diff, for a renderer that draws one.
 */
/** `git.diff`'s params for one file of a turn. */
export function turnDiffParams(item, path, session = {}) {
    return {
        rootId: item.rootId,
        checkpoint: item.checkpoint,
        path,
        ...(session.conversationId ? { conversationId: session.conversationId } : session.sessionId ? { sessionId: session.sessionId } : {}),
    };
}
/** The files of a `git.diff` answer as one unified diff: a `diff --git` header per file, then its hunks. */
export function unifiedPatchOf(files) {
    const out = [];
    for (const f of files) {
        const from = f.oldPath ?? f.path;
        out.push(`diff --git a/${from} b/${f.path}`);
        out.push(f.status === "added" ? "--- /dev/null" : `--- a/${from}`);
        out.push(f.status === "deleted" ? "+++ /dev/null" : `+++ b/${f.path}`);
        for (const h of f.hunks) {
            out.push(`@@ -${h.oldStart},${h.oldLines} +${h.newStart},${h.newLines} @@`);
            for (const l of h.lines)
                out.push(`${l.kind}${l.text}`);
        }
    }
    return out.join("\n");
}
/** What to say instead of lines, when a file has none to show. */
export function turnDiffEmptyWords(file, note) {
    if (!file)
        return note?.trim() || "The workbench found no change to this file at that turn.";
    if (file.binary)
        return "A binary file: there are no lines to show.";
    if (!file.hunks.length)
        return file.truncated?.reason ?? (file.status === "renamed" ? "Renamed, with no lines changed." : "No lines to show.");
    return undefined;
}
//# sourceMappingURL=turnDiff.js.map